/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KeyValuePair } from './keyValuePair';


export interface ProviderComponentUsageInfo { 
    protection?: Array<KeyValuePair>;
    recovery?: Array<KeyValuePair>;
    storage?: Array<KeyValuePair>;
}

